module.exports = __webpack_public_path__ + "dash_20_app_assets/img/avatar-s-26.fda3c31e.jpg";